module.exports = __webpack_public_path__ + "media/images/thumbnail_temp_akaire_pdf-8359a10f.png";